import { render, staticRenderFns } from "./SectionSponsors.vue?vue&type=template&id=18315fb4&scoped=true"
import script from "./SectionSponsors.vue?vue&type=script&lang=js"
export * from "./SectionSponsors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18315fb4",
  null
  
)

export default component.exports